define('Search',[
    'jquery',
    'ANSI/Utility/Dimensions',
    'ANSI/Utility/SitecoreUtils',
    'eventManager',
    'promise-polyfill',
], function ($, dimensions, sitecoreUtils, eventManager) {
    'use strict';
    var searchpage = {
        init: function () {           
            if ($('.CoveoSearchInterface').length == 0 || $('.CoveoSearchInterface').length) {          
                searchpage.headerSearchOpen();
                searchpage.headerSearchClose();
                searchpage.filterButton();
                if (document.querySelector('.coveo-facet-column'))
                    searchpage.facetColumnHide();
                if (dimensions.width > 991) searchpage.facetCollapse();
            }
        },
        facetCollapse: function () {
            // Highjack coveo collapse and make it work with click on header
            $('.coveo-facet-header').on('click', function () {
                $(this)
                    .closest('.CoveoFacet')
                    .toggleClass('coveo-facet-collapsed');
            });

            $('.coveo-facet-values').on('click', function (e) {
                e.stopPropagation();
            });

            $('.coveo-facet-header-settings-section').on('click', function (e) {
                e.stopPropagation();
            });
        },
        facetColumnHide: function () {
            eventManager.subscribe('SearchResultsLoadedEvent', function () {
                var column = document.querySelector('.coveo-facet-column');  
                //fix upgrade
                setTimeout(function () {
                    $('a.coveo-facet-dropdown-header').on("click", function () {
                        column.style.display = 'block';
                        $('.coveo-facet-modal-close-button').hide();
                        $('body').css('overflow', 'unset');
                        setTimeout(function () {
                            if (jQuery('.coveo-facet-dropdown-modal-content').is(':visible')) {
                                if ($('.coveo-dropdown-background').length == 0) {
                                    $('.CoveoSearchInterface').append('<div class="coveo-dropdown-background coveo-dropdown-background-active" style="opacity: 0.9;"></div>');
                                }
                            } else {
                                $('.coveo-dropdown-background-active').remove();
                                column.style.display = 'none';
                            }
                        }, 50);
                    });
                }, 0);

              
                var facetButton = document.querySelector(
                    '.coveo-dropdown-header-wrapper'
                );
                if (
                    column.querySelector('.CoveoCategoryFacet') &&
                    column.querySelector('.CoveoFacet')
                ) {
                    if (
                        column.querySelectorAll('.CoveoCategoryFacet').length ==
                            column.querySelectorAll(
                                '.CoveoCategoryFacet.coveo-hidden'
                            ).length &&
                        column.querySelectorAll('.CoveoFacet').length ==
                            column.querySelectorAll(
                                '.CoveoFacet.coveo-facet-empty'
                            ).length
                    ) {
                        if (
                            document.querySelector(
                                '.coveo-dropdown-header-wrapper'
                            )
                        )
                            facetButton.style.display = 'none';
                        column.style.display = 'none';
                    } else {
                        if (
                            document.querySelector(
                                '.coveo-dropdown-header-wrapper'
                            )
                        )
                            facetButton.style.display = 'inline-flex';
                        if (dimensions.width < 992) {
                            if (
                                document.querySelector(
                                    '.coveo-dropdown-content'
                                )
                            ) {
                                document.querySelector(
                                    '.coveo-dropdown-content'
                                ).style.display = 'block';
                            }
                        } else {
                            column.style.display = 'block';
                        }
                    }
                } else if (
                    column.querySelector('.CoveoFacet') ||
                    column.querySelector('.CoveoCategoryFacet')
                ) {
                    if (
                        column.querySelector('.coveo-hidden') ||
                        column.querySelector('.coveo-empty-facet')
                    ) {
                        if (
                            document.querySelector(
                                '.coveo-dropdown-header-wrapper'
                            )
                        )
                            facetButton.style.display = 'none';
                        column.style.display = 'none';
                    } else {
                        if (
                            document.querySelector(
                                '.coveo-dropdown-header-wrapper'
                            )
                        )
                            facetButton.style.display = 'inline-flex';
                        if (dimensions.width < 992) {
                            if (
                                document.querySelector(
                                    '.coveo-dropdown-content'
                                )
                            ) {
                                document.querySelector(
                                    '.coveo-dropdown-content'
                                ).style.display = 'block';
                            }
                        } else {
                            column.style.display = 'block';
                        }
                    }
                }
            });
        },
        filterButton: function () {
            $('.coveo-facet-dropdown-header').on("click", function () {
                $(
                    '.coveo-facet-dropdown-header.coveo-dropdown-header-active p'
                ).toggleClass('apply');
                $('.coveo-facet-dropdown-modal-content').addClass('coveo-facet-dropdown-content');
                $('.coveo-facet-modal-close-button').hide();
                $('body').css('overflow', 'unset');
                if ($('.coveo-dropdown-background').size() == 0) {
                    $('.CoveoSearchInterface').append('<div class="coveo-dropdown-background coveo-dropdown-background-active" style="opacity: 0.9;"></div>');
                    
                } else {
                    $('.coveo-dropdown-background').remove();
                }
            });
        },
        headerSearchOpen: function () {
            $('.score-image-button.desktop-search-button').on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();  
                $('.score-style-box.search-box').toggleClass('open');              
                setTimeout(function () {
                    $('header .CoveoSearchbox').find('input').focus();
                }, 300);

                if ($('.score-style-box.search-box').hasClass('open')) {
                    $('body').addClass('open');
                    $('.desktop-search-button').addClass('active');
                } else {
                    $('body').removeClass('open');
                    $('.desktop-search-button').removeClass('active');
                }
            });
            $('.score-style-box.mobile-search-button').on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                if ($('.navbar-collapse.collapse.in ').length) {
                    $('.navbar-toggle').trigger("click");
                }

                $('.score-style-box.search-box').addClass('open');
                $('body').addClass('open');
            });
            var srchBtn = $('.desktop-search-button').closest(
                '.score-style-box'
            );
            // close searchbar after pressing enter
            srchBtn.attr({ tabindex: '0' });
            srchBtn.on('keyup', function (e) {
                if (e.keyCode == 13) {
                    $('.desktop-search-button').trigger("click");
                }
            });
        },
        headerSearchClose: function () {
            $('.search-box .score-image-button').on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                $('.score-style-box.search-box').removeClass('open');
            });
            // close searchbar when menu item is clicked
            $('.ansi-header .score-megamenu-dropdown').on("click", function () {
                $('.score-style-box.search-box').removeClass('open');
                $('.desktop-search-button').removeClass('active');
                $('body').removeClass('open');
            });
            $(document).on("click", function (e) {
                // close searchbar unless clicking in searchbar
                if ($('.search-box.open').has(e.target).length === 0) {
                    $('.score-style-box.search-box').removeClass('open');
                    $('.desktop-search-button').removeClass('active');
                    $('body').removeClass('open');
                }
            });
            $(document).keyup(function (e) {
                // close searchbar on esc key press
                if (!e) e = event;
                if (e.keyCode == 27) {
                    e.stopPropagation();
                    $('.score-style-box.search-box').removeClass('open');
                    $('.desktop-search-button').removeClass('active');
                    $('body').removeClass('open');
                }
            });
        },
    };
    if (!sitecoreUtils.prototype.isEditing())
        Promise.resolve().then(searchpage.init);
});

